import React from 'react';

export default function IcebreakerParticipantTimerHeader({
  timer = '00:59',
  subheading = 'Keep your answers short, honest, and to the point—then pass it back',
}) {
  // Parse the provided timer string (supports MM:SS or HH:MM:SS)
  const parts = String(timer).split(':');
  const hasHours = parts.length === 3;
  const [h, m, s] =
    hasHours ? parts : ['--', parts[0] ?? '--', parts[1] ?? '--'];

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>
        Match is{' '}
        <span style={styles.highlight}>
          <span style={styles.highlightText}>Live</span>
        </span>
      </h1>

      <div style={styles.subheading}>{subheading}</div>

      <div style={styles.timerWrapper}>
        <div style={styles.timerLabelPill}>Timer Ends IN</div>

        <div style={styles.digitsRow} aria-live="polite">
          {hasHours && (
            <>
              <span style={styles.digit}>{h.padStart(2, '0')[0]}</span>
              <span style={styles.digit}>{h.padStart(2, '0')[1]}</span>
              <span style={styles.colon}>:</span>
            </>
          )}
          <span style={styles.digit}>{m.padStart(2, '0')[0]}</span>
          <span style={styles.digit}>{m.padStart(2, '0')[1]}</span>
          <span style={styles.colon}>:</span>
          <span style={styles.digit}>{s.padStart(2, '0')[0]}</span>
          <span style={styles.digit}>{s.padStart(2, '0')[1]}</span>
        </div>
      </div>
    </div>
  );
}

/* ────────────────────────────────────────── */
/* Styles matched to HeaderAndTimer + crooked highlight */
const styles = {
  container: {
    boxSizing: 'border-box',
    maxWidth: 680,
    width: '80%',
    margin: '12px auto 0',
    padding: '0 12px',
    fontFamily:
      "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
    textAlign: 'center',
    color: '#0b0b0b',
  },

  title: {
    margin: 0,
    fontSize: '1.85rem',
    fontWeight: 800,
    lineHeight: 1.2,
    letterSpacing: '-0.01em',
  },

  // Crooked highlight pill
  highlight: {
    display: 'inline-block',
    padding: '3px 10px',
    paddingBottom: 4,
    borderRadius: 6,
    backgroundColor: '#3579F6',
    color: '#fff',
    transform: 'skewX(-8deg) rotate(-2deg)', // crooked like sticker
  },
  highlightText: {
    display: 'inline-block',
    transform: 'skewX(8deg) rotate(2deg)', // straighten the text
  },

  subheading: {
    marginTop: 6,
    fontSize: '.9rem',
    color: '#6b7280',
    fontWeight: 500,
    lineHeight: 1.45,
  },

  timerWrapper: {
    marginTop: '18px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  timerLabelPill: {
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: 999,
    background: '#fff',
    border: '1px solid #e5e7eb',
    fontSize: '.7rem',
    color: '#374151',
    fontWeight: 800,
    letterSpacing: '.06em',
    textTransform: 'uppercase',
    marginBottom: 8,
  },

  digitsRow: { display: 'flex', alignItems: 'baseline', gap: 4 },
  digit: {
    display: 'inline-block',
    fontSize: '2.5rem',
    lineHeight: 1,
    fontWeight: 900,
    letterSpacing: '-0.02em',
    color: '#0f172a',
    fontVariantNumeric: 'tabular-nums',
    marginTop: 8,
  },
  colon: {
    fontSize: '2rem',
    fontWeight: 900,
    color: '#9ca3af',
    lineHeight: 1,
    padding: '8px 4px',
    transform: 'translateY(-5px)',
  },
};
